import { BottomSheet } from '@pos/ui';
import { Check, ChevronDown, Store } from 'lucide-react';
import { useState } from 'react';
import { useBranch, useBranches } from './data';

/** "Все филиалы ▾" — shown only when the business has more than one branch. */
export function BranchChip() {
  const { data } = useBranches();
  const { branchId, set } = useBranch();
  const [open, setOpen] = useState(false);
  const branches = (data ?? []).filter((b) => b.isActive !== false);
  if (branches.length < 2) return null;
  const current = branches.find((b) => b.id === branchId);
  const pick = (id: string | null) => {
    set(id);
    setOpen(false);
  };
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex h-11 min-w-0 items-center gap-1.5 rounded-full border border-line bg-surface px-4 text-md font-medium active:bg-sunken"
      >
        <Store className="size-4 shrink-0 text-ink-3" />
        <span className="truncate">{current?.name ?? 'Все филиалы'}</span>
        <ChevronDown className="size-4 shrink-0 text-ink-3" />
      </button>
      <BottomSheet open={open} onOpenChange={setOpen} title="Филиал">
        <ul className="overflow-hidden rounded-lg border border-line">
          {[{ id: null, name: 'Все филиалы' }, ...branches].map((b) => (
            <li key={b.id ?? 'all'} className="border-b border-line last:border-b-0">
              <button type="button" onClick={() => pick(b.id)} className="flex min-h-14 w-full items-center gap-3 px-4 text-left text-md active:bg-sunken">
                <span className="flex-1">{b.name}</span>
                {branchId === b.id && <Check className="size-5 text-primary" />}
              </button>
            </li>
          ))}
        </ul>
      </BottomSheet>
    </>
  );
}
